import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';

/* We really don't want to be doing these sorts of tricks,
   but our modals are too inconsistent to add this as a distinct
   style in `fe-co-modal` yet - we'd need to ensure we had a standard "Allhomes" style
   first
*/
export var modal = /*#__PURE__*/css("div:first-of-type > div:first-of-type > div:first-of-type{margin:3px;> button{display:block;margin:16px;outline:none;float:right;", media('>=tablet'), "{display:none;}}}");
export var headerSection = /*#__PURE__*/css("display:none;text-align:center;margin:100px auto 30px;width:118px;height:24px;", media('>=tablet'), "{display:block;}");
export var container = /*#__PURE__*/css("margin:0 auto;padding:0 24px 20px;max-width:400px;", media('>=tablet'), "{padding:20px 24px;}.domain-icon.is-regular{width:24px;height:24px;}.domain-select .Select-control{height:40px;padding:8px 15px;}");